import { useCallback } from 'react';

import { OpCoListContent, useOptionalContent } from '../../lib/services/content';

import { useCookies } from './useCookies';

export const useSafeCookies = () => {
  const {
    setOpco: setOpCoCookie,
    setMarket: setMarketCookie,
    setLocale: setLocaleCookie,
    locale: currentLocale,
    market: currentMarket,
    opco: currentOpCo,
  } = useCookies();
  const { data: opcos } = useOptionalContent(OpCoListContent);

  const setLocale = useCallback(
    (newLocale: string) => {
      setLocaleCookie(newLocale);
      // replace URL segments for current locale with new locale instead
      window.location.href = window.location.href.replace(new RegExp(`\\/${currentLocale}`, 'gi'), `/${newLocale}`);
    },
    [setLocaleCookie, currentLocale]
  );

  const setOpco = useCallback(
    (id: string) => {
      if (id === currentOpCo || !opcos?.some((opco) => opco.id === id)) {
        return;
      }

      const targetOpco = opcos.find((opco) => opco.id === id);

      if (!targetOpco) {
        return;
      }

      setOpCoCookie(id);

      // if current market isn't valid in the new opco default to the first market
      if (!targetOpco.markets.some((market) => market.id === currentMarket)) {
        setMarketCookie(targetOpco.markets[0].id);
      }

      // if current locale isn't valid in the new opco default to the first locale
      if (!targetOpco.locales.some((locale) => locale.id === currentLocale)) {
        const newLocale = targetOpco.locales[0].id;
        setLocale(newLocale);
        return;
      }

      window.location.reload();
    },
    [currentOpCo, opcos, setOpCoCookie, currentMarket, currentLocale, setMarketCookie, setLocale]
  );

  return {
    locale: currentLocale,
    market: currentMarket,
    opco: currentOpCo,
    setOpco,
    setMarket: setMarketCookie,
    setLocale,
  };
};
